import React, { Component } from 'react';

import InputBox from '../../../../etc/InputBox';

import UpdateItem from './update'
import QuestionItem from './question'
import ReviewItem from './review'

class CommunicatoinForm extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  onChange = (e) => {
    console.log(e);
  };

  render() {
    return (
      <>
        <form className="mt-4">
          <div className="row mb-2">
            <div className="col-md-12">
              <InputBox
                title="논문 명"
                value={[{ value : "20Clinical Results of Distal Embolization in Grade V Splenic Injury : Four-Year Experience from a Single Regional Trauma Center" }]}
              />
            </div>
          </div>
          <UpdateItem />
          <QuestionItem />
          <ReviewItem />
        </form>
      </>
    )
  }
}

export default CommunicatoinForm;
